export default __webpack_public_path__ + "static/media/BG-DarkBlue-0006.fed042a1.png";